interface RoastChartLegendProps {
  legendItems: { key: string; label: string; color: string }[];
  variant: 'inline' | 'modal';
}

/** Colored-swatch legend shown above the roast chart, in both the inline card and the zoom modal. */
export function RoastChartLegend({ legendItems, variant }: RoastChartLegendProps) {
  const isModal = variant === 'modal';
  return (
    <div
      className={`flex flex-wrap justify-center items-center gap-x-1.5 gap-y-1 ${
        isModal ? 'sm:gap-x-6 sm:gap-y-3 text-[9px] sm:text-sm mb-2 sm:mb-4' : 'sm:gap-x-4 sm:gap-y-2 text-[8px] sm:text-xs mb-3'
      }`}
    >
      {legendItems.map(item => (
        <div key={item.key} className="flex items-center gap-0.5 sm:gap-2">
          <span
            className={`inline-block h-1.5 w-1.5 ${isModal ? 'sm:h-3 sm:w-3' : 'sm:h-2.5 sm:w-2.5'} rounded-sm`}
            style={{ backgroundColor: item.color }}
          />
          <span className="text-gray-700">{item.label}</span>
        </div>
      ))}
    </div>
  );
}
